import Vue from 'vue'
import App from './App.vue'
import VueMeta from 'vue-meta'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';

Vue.use(VueMeta)
Vue.use(VueToast)

Vue.config.productionTip = false

window.vm = {}

new Vue({
  render: h => h(App),
}).$mount('#app')
